(function () {
  function setOpen(itemEl, open) {
    const btn = itemEl.querySelector('.phibra-faqs__question');
    const panel = itemEl.querySelector('.phibra-faqs__answercont');
    if (!btn || !panel) return;

    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.classList.add('is-open');
      itemEl.classList.add('is-open');
    } else {
      panel.style.maxHeight = '0px';
      btn.classList.remove('is-open');
      itemEl.classList.remove('is-open');
    }
  }

  function init(root) {
    const singleOpen = root.getAttribute('data-single-open') === '1';
const openFirstAttr = root.getAttribute('data-open-first');
const openFirst = openFirstAttr === null ? true : openFirstAttr === '1';

    const items = Array.from(root.querySelectorAll('.phibra-faqs__item'));
    if (!items.length) return;

    items.forEach((it) => setOpen(it, false));
    if (openFirst) setOpen(items[0], true);

    items.forEach((item) => {
      const btn = item.querySelector('.phibra-faqs__question');
      if (!btn) return;

      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (singleOpen) {
          items.forEach((it) => {
            if (it !== item) setOpen(it, false);
          });
        }

        // ✅ toggle normal => pode ficar tudo fechado
        setOpen(item, !isOpen);
      });
    });

    window.addEventListener('resize', () => {
      items.forEach((it) => {
        const btn = it.querySelector('.phibra-faqs__question');
        const panel = it.querySelector('.phibra-faqs__answercont');
        if (!btn || !panel) return;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-phibra-faqs="1"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
